import axiosConfig from '../../utils/axiosConfig';

const AdminUserManagement = {
  // Create a new user (admin only)
  createUser: async (userData) => {
    try {
      const response = await axiosConfig.post('/api/admin/user-management/create-user', userData);
      return response.data;
    } catch (error) {
      console.error('Error creating user:', error);
      throw error;
    }
  },

  // Reset user password (admin only)
  resetUserPassword: async (userId, newPassword) => {
    try {
      const response = await axiosConfig.post('/api/admin/user-management/reset-password', {
        userId,
        newPassword
      });
      return response.data;
    } catch (error) {
      console.error('Error resetting password:', error);
      throw error;
    }
  },

  // Delete user (admin only)
  deleteUser: async (userId) => {
    try {
      const response = await axiosConfig.delete(`/api/admin/user-management/delete-user/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting user:', error);
      throw error;
    }
  }
};

export default AdminUserManagement;